module.exports = __webpack_public_path__ + "img/tr2.251e4939.png";